import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import environment from '../config/environment';

const BudgetContext = createContext();

export const BudgetProvider = ({ children }) => {
  const [budget, setBudget] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useAuth();
  const { apiUrl } = environment();

  const fetchBudget = async (causeId) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/causes/${causeId}/budget`,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      if (!response.ok) throw new Error('Failed to fetch budget data');
      const data = await response.json();
      setBudget(data);
      setError(null);
    } catch (err) {
      setError(err.message);
      setBudget(null);
    } finally {
      setLoading(false);
    }
  };

  const refreshBudget = async () => {
    if (budget?.causeId) {
      await fetchBudget(budget.causeId);
    }
  };

  const value = {
    budget,
    loading,
    error,
    fetchBudget,
    refreshBudget
  };

  return (
    <BudgetContext.Provider value={value}>
      {children}
    </BudgetContext.Provider>
  );
};

export const useBudget = () => {
  const context = useContext(BudgetContext);
  if (!context) {
    throw new Error('useBudget must be used within a BudgetProvider');
  }
  return context;
}; 